var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizedPersonnel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 79.474 79.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16802",
    "data-name": "Group 16802",
    transform: "translate(-144 -4577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32475",
    "data-name": "Path 32475",
    d: "M33.276,2A18.276,18.276,0,1,0,51.551,20.276,18.276,18.276,0,0,0,33.276,2Z",
    transform: "translate(129 4575)",
    fill: "#ffdcbb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(154.141 4586.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "athorized"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32609",
    "data-name": "Path 32609",
    d: "M68.833,32.226A12.074,12.074,0,0,0,58.539,20.3V1.476A1.489,1.489,0,0,0,56.921.019a1.457,1.457,0,0,0-1,.4,18.4,18.4,0,0,1-25.491,0,1.8,1.8,0,0,0-2.314,0A18.4,18.4,0,0,1,2.59.424,1.473,1.473,0,0,0,1.618,0,1.473,1.473,0,0,0,0,1.459v39C0,56.649,27.514,69.078,28.679,69.6c1.311.939,25.669-11.426,29.343-25.313A12.09,12.09,0,0,0,68.833,32.226ZM42.355,58.866a87.98,87.98,0,0,1-13.093,7.752C19.017,61.957,2.411,50.466,2.913,40.464V4.5A21.364,21.364,0,0,0,29.262,3.321,21.38,21.38,0,0,0,55.626,4.5V20.217C41.5,21.836,41.06,41.807,55,44.17c-1.861,5.826-7.639,11.07-12.64,14.7Zm14.4-17.479a9.177,9.177,0,0,1-9.16-9.16c.437-12.106,17.884-12.106,18.321,0A9.177,9.177,0,0,1,56.759,41.387Z",
    transform: "translate(0 0.004)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32610",
    "data-name": "Path 32610",
    d: "M42.784,17.853a1.473,1.473,0,0,0-2.072,0L36.6,21.964l-1.618-1.618A1.457,1.457,0,0,0,32.928,22.4l2.67,2.67a1.457,1.457,0,0,0,2.055,0l5.13-5.1a1.457,1.457,0,0,0,0-2.12Z",
    transform: "translate(20.141 10.785)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32611",
    "data-name": "Path 32611",
    d: "M20.9,25.571a7.493,7.493,0,0,0,0-14.971C11.06,10.924,11.06,25.263,20.9,25.571Zm0-12.057a4.58,4.58,0,0,1,0,9.144,4.58,4.58,0,0,1,0-9.144Z",
    transform: "translate(8.361 6.563)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32612",
    "data-name": "Path 32612",
    d: "M26.916,20.67a1.473,1.473,0,0,0-1.376.324,4.321,4.321,0,0,1-5.794,0,1.473,1.473,0,0,0-1.376-.324c-10.115,2.638-10.617,18.612.842,19.114h6.878C37.533,39.283,37.08,23.308,26.916,20.67Zm4.677,11.621a5.616,5.616,0,0,1-5.5,4.58H19.277c-7.655-.308-7.024-11.086-.728-13.174a7.283,7.283,0,0,0,8.335,0A7.688,7.688,0,0,1,31.594,32.291Z",
    transform: "translate(6.618 12.758)",
    fill: "#2a3d57",
    stroke: "#2a3d57",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizedPersonnel);
export default __webpack_public_path__ + "static/media/AuthorizedPersonnel.0933d4c305f2fdbcaca2cb7ac6cc37d7.svg";
export { ForwardRef as ReactComponent };